import React, { Component } from 'react';

import Loader from '../components/common/loader';

import apiFetcher from '../tools/api-fetcher';

export default class TermsAndConditions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			content: '',
			isError: false,
			isLoading: false
		};
	}

	componentWillMount() {
		this.setState({ isLoading: true });

		try {
			apiFetcher.get('public/terms-and-conditions')
				.then(result => {
					this.setState({
						content: result.data,
						isLoading: false
					});
				});
		} catch(error) {
			this.setState({ isError: true })
		}
	}

	renderErrorMessage() {
		const { isError } = this.state;

		if (!isError) {
			return null;
		}

		return (
			<div className="alert alert-danger" role="alert">Failed to load Terms and Conditions</div>
		);
	}

	render() {
		const { content, isLoading } = this.state;

		return (
			<div className="main-section segment">
				<div className="main-section_inner-border">
					<div className="main-section__header">
            <h3 className="main-content__title">Terms and Conditions</h3>
          </div>

					{this.renderErrorMessage()}

					<div dangerouslySetInnerHTML={{ __html: content }} />

					<Loader visible={isLoading} />
				</div>
			</div>  
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/terms-and-conditions.js